module.exports = __webpack_public_path__ + "static/media/facebook_feed.6fbc8ece.svg";